import { useCallback } from 'react';
import useRedirect from '~/client/hooks/router/useRedirect';
import useRouter from '~/client/hooks/router/useRouter';
import useAgentData from '~/client/hooks/useAgentData';
import useSite from '~/client/hooks/useSite';
import Translate from '~/client/shared/i18n/Translate';
import Keyline from '~/client/shared/Keyline';
import useParseExternalHref from '~/client/shared/NextLink/useNextLink/useParseExternalHref';
import useAccountPopoverStore from '~/client/store/useAccountPopoverStore';

const LoginLink: FC = () => {
  const { handleClick } = useLoginLink();
  return (
    <div className="grid gap-4">
      <Keyline />
      <div
        className="inline cursor-pointer bg-transparent p-0 font-[inherit] text-moon-16 text-piccolo"
        onClick={handleClick}
      >
        <Translate id="casino.sign_in" />
      </div>
    </div>
  );
};

const useLoginLink = () => {
  const { showPopover } = useAccountPopoverStore();
  const { isMobile } = useAgentData();
  const router = useRouter();
  const { isBridgeSite } = useSite();
  const { parseExternalHref } = useParseExternalHref();
  const { redirect } = useRedirect();
  const handleClick = useCallback(() => {
    if (isBridgeSite) {
      redirect(parseExternalHref('/login'));
      return;
    }

    if (isMobile) {
      router.push(`/login?redirect=${router.asPath}`);
      return;
    }

    showPopover('login');
  }, [
    isMobile,
    router,
    isBridgeSite,
    redirect,
    showPopover,
    parseExternalHref,
  ]);
  return { handleClick };
};

export default LoginLink;
